import { useMemo } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import { BaseTextProps } from './BaseText.types';
import { parseTextLines, isSafeTextChild } from './BaseText.utils';


export interface UseBaseTextLogicParams extends BaseTextProps {
  conversionStyleMap: Record<string, StyleProp<TextStyle>>;
  conversionKeys: { BOLD: string; ITALIC: string };
}

export const useBaseTextLogic = ({ children, conversionStyleMap, conversionKeys }: UseBaseTextLogicParams) => {
  const textLines = useMemo(() => {
    let textToParse = '';

    if (Array.isArray(children)) {
      const allSafeChildren = children.every(isSafeTextChild);
      if (allSafeChildren) {
        textToParse = children.join('');
      }
    } else if (typeof children === 'string' || typeof children === 'number') {
      textToParse = String(children);
    } else {
      textToParse = children?.toString() || '';
    }

    const lines = textToParse.split('\n');
    return parseTextLines(lines, conversionStyleMap, conversionKeys);
  }, [children, conversionStyleMap, conversionKeys]);

  return {
    textLines,
  };
};

